import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }

import TrustItem from "@/components/TrustItem.vue";
import { pushEvent } from "@/services/dataLayerLogin";
import { country } from "@ocm/services/ocm-object";
import { store } from "@/state/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'Trust',
  props: {
    loginWrapper: {}
  },
  setup(__props: any) {



function sendTracking(event: MouseEvent) {
	const trackedElement = event?.currentTarget as HTMLElement;
	const indexOfElement = [...(trackedElement.parentElement as HTMLElement).children].indexOf(trackedElement) + 1;
	pushEvent(`IconNo${indexOfElement}`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TrustItem, {
      src: "europes-no1-outlet-01.svg",
      label: _ctx.$t('trust.seal_1'),
      caption: _ctx.$t('trust.seal_1_html'),
      "info-text": _ctx.$t('trust.seal_1_text').replace('{country}', _unref(country)),
      "login-wrapper": _ctx.loginWrapper,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (sendTracking($event)))
    }, null, 8, ["label", "caption", "info-text", "login-wrapper"]),
    (_unref(store).isClassic)
      ? (_openBlock(), _createBlock(TrustItem, {
          key: 0,
          src: "trip-advisor_de_DE_cut.svg",
          label: _ctx.$t('trust.seal_3'),
          caption: _ctx.$t('trust.seal_3_html'),
          "info-text": _ctx.$t('trust.seal_3_text'),
          "login-wrapper": _ctx.loginWrapper,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (sendTracking($event)))
        }, null, 8, ["label", "caption", "info-text", "login-wrapper"]))
      : _createCommentVNode("", true),
    _createVNode(TrustItem, {
      src: "bester-online-shop-glamour.svg",
      label: _ctx.$t('trust.seal_2'),
      caption: _ctx.$t('trust.seal_2_html'),
      "info-text": _ctx.$t('trust.seal_2_text'),
      "login-wrapper": _ctx.loginWrapper,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (sendTracking($event)))
    }, null, 8, ["label", "caption", "info-text", "login-wrapper"])
  ]))
}
}

})